/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';

const selectJobSearchEngine                    = ({jobsearchengine}) => jobsearchengine;
const selectJobSearchEngineActiveTab           = (state) => selectJobSearchEngine(state).activeTab;
const selectJobSearchEngineTabs                = (state) => selectJobSearchEngine(state).tabs;
const selectJobSearchEngineAutoJobs            = (state) => selectJobSearchEngine(state).autoJobs;
const selectJobSearchEngineJobs                = (state) => selectJobSearchEngine(state).jobs;
const selectJobSearchEngineGridColumnState     = (state) => selectJobSearchEngine(state).grid.columnState;
const selectJobSearchEngineGridPageSize        = (state) => selectJobSearchEngine(state).grid.pageSize;
const selectJobSearchEngineGridRefreshRequired = (state) => selectJobSearchEngine(state).grid.refreshRequired;
const selectIsFacetOpen                        = (state) => selectJobSearchEngine(state).isFacetOpen;
const selectViewSubGroups                      = (state) => selectJobSearchEngine(state).grid.viewSubGroups;

export const jobSearchEngineActiveTabSelector = createSelector(
  selectJobSearchEngineActiveTab,
  (activeTab) => activeTab
);

export const jobSearchEngineAutoJobsSelector = createSelector(
  selectJobSearchEngineAutoJobs,
  (autoJobs) => autoJobs
);

export const jobSearchEngineJobsSelector = createSelector(
  selectJobSearchEngineJobs,
  (jobs) => jobs
);

export const jobSearchEngineTabsSelector = createDeepEqualSelector(
  selectJobSearchEngineTabs,
  (tabs) => tabs
);

export const jobSearchEngineGridColumnStateSelector = createDeepEqualSelector(
  selectJobSearchEngineGridColumnState,
  (columnState) => columnState
);

export const jobSearchEngineGridRefreshRequiredSelector = createSelector(
  selectJobSearchEngineGridRefreshRequired,
  (refreshRequired) => refreshRequired
);

export const isFacetOpenSelector = createSelector(
  selectIsFacetOpen,
  (isFacetOpen) => isFacetOpen
);

export const jobSearchEngineGridPageSizeSelector = createSelector(
  selectJobSearchEngineGridPageSize,
  (pageSize) => pageSize
);

export const viewSubGroupsSelector = createSelector(
  selectViewSubGroups,
  (viewSubGroups) => viewSubGroups
);

const selectJobCancel         = ({jobsearchengine: {cancel}}) => cancel;
const selectJobCancelSelected = state => selectJobCancel(state).selected;
const selectCancelShowDialog  = state => selectJobCancel(state).isEditing;

export const jobCancelSelectedSelector = createDeepEqualSelector(
  selectJobCancelSelected, (selected) => selected
);

export const jobCancelShowDialogSelector = createSelector(
  selectCancelShowDialog, (isEditing: boolean) => isEditing
);

const selectTaskCancel   = ({jobsearchengine: {cancelTask}}) => cancelTask;
const selectTaskSelected = state => selectTaskCancel(state).taskSelected;
const selectTaskEditing  = state => selectTaskCancel(state).isEditing;

export const taskCancelDeviceSelectedSelector = createDeepEqualSelector(
  selectTaskSelected, (taskSelected) => taskSelected
);

export const taskCancelShowDialogSelector = createSelector(
  selectTaskEditing, (isEditing: boolean) => isEditing
);

const selectDeviceCancel   = ({jobsearchengine: {cancelDevice}}) => cancelDevice;
const selectedDevice       = state => selectDeviceCancel(state).selected;
const selectDeviceSelected = state => selectDeviceCancel(state).deviceSelected;
const selectDeviceEditing  = state => selectDeviceCancel(state).isEditing;

export const deviceCancelSelectedSelector = createDeepEqualSelector(
  selectedDevice, (selected) => selected
);

export const deviceCancelDeviceSelectedSelector = createDeepEqualSelector(
  selectDeviceSelected, (deviceSelected) => deviceSelected
);

export const deviceCancelShowDialogSelector = createSelector(
  selectDeviceEditing, (isEditing: boolean) => isEditing
);

const selectJobSearchEngineRerun                 = ({jobsearchengine: {rerun}}) => rerun;
const selectJobSearchEngineRerunSelected         = state => selectJobSearchEngineRerun(state).selected;
const selectJobSearchEngineRerunShowDialog       = state => selectJobSearchEngineRerun(state).isEditing;
const selectJobSearchEngineRerunFailedShowDialog = state => selectJobSearchEngineRerun(state).reRunFailed;
const selectJobSearchEngineRerunTaskShowDialog   = state => selectJobSearchEngineRerun(state).reRunTask;

export const jobSearchEngineRerunSelectedSelector = createDeepEqualSelector(
  selectJobSearchEngineRerunSelected, (selected) => selected
);

export const jobSearchEngineRerunShowDialogSelector = createSelector(
  selectJobSearchEngineRerunShowDialog, (isEditing: boolean) => isEditing
);

export const jobSearchEngineRerunFailedShowDialogSelector = createSelector(
  selectJobSearchEngineRerunFailedShowDialog, (reRunFailed: boolean) => reRunFailed
);

export const jobSearchEngineRerunTaskShowDialogSelector = createSelector(
  selectJobSearchEngineRerunTaskShowDialog, (reRunTask: boolean) => reRunTask
);
